// extracted by mini-css-extract-plugin
export var integrationButton = "_a1-0";